import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { useLogout } from '../../hooks/useLogout';
import { useTranslation } from 'react-i18next'; // Import translation hook
import '../../style/AccountPage.css'; // Import the CSS file

const SettingsPage = () => {
  const { id } = useParams();
  const { logout } = useLogout();
  const navigate = useNavigate();
  const { t } = useTranslation(); // Translation function
  const [user, setUser] = useState(null);
  const [error, setError] = useState(null);
  const baseUrl = process.env.REACT_APP_API_URL || 'http://localhost:5000';

  useEffect(() => {
    const fetchUser = async () => {
      try {
        const user = JSON.parse(localStorage.getItem('user')); // Get the user from localStorage
        const token = user?.token; // Extract the token

        if (!token) {
          throw new Error(t('general.noAuthToken')); // Use translation for error
        }

        const response = await fetch(`${baseUrl}/api/users/account/${id}`, {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${token}`, // Include the token in the Authorization header
          },
        });

        if (!response.ok) {
          throw new Error(t('accountPage.userNotFound')); // Use translation for error
        }
        const data = await response.json();
        setUser(data);
      } catch (error) {
        setError(error.message);
        console.error(error);
      }
    };

    fetchUser();
  }, [id, baseUrl, t]);

  if (error) {
    return <div className="error-message text-red-500 text-center">{t('accountPage.error')}: {error}</div>;
  }

  if (!user) {
    return <div className="loading-message text-dafauna-gray text-center">{t('accountPage.loading')}</div>;
  }

  const handleEditClick = () => {
    navigate(`/edit-settings/${id}`);
  };

  const languageDisplayName = {
    en: 'English', // "English"
    es: 'Español', // "Español"
  };

  return (
    <div className="account-page bg-dafauna-background rounded-xl shadow-md p-8">
      <div className="account-container">
        <h1 className="account-title text-dafauna-darkText text-2xl font-bold text-center mb-4">
          {t('settingsPage.title')}
        </h1>
        <div className="account-details-container flex justify-between items-center mb-4">
          <div className="account-details text-dafauna-darkText">
            <p>
              <strong>{t('settingsPage.preferredLanguage')}:</strong>{' '}
              {languageDisplayName[user.language] || user.language} {/* Display the mapped language name */}
            </p>
          </div>
          <button
            className="btn edit-account-btn bg-dafauna-primary text-white rounded-md px-4 py-2 hover:bg-dafauna-primaryLight"
            onClick={handleEditClick}
          >
            {t('settingsPage.editButton')}
          </button>
        </div>
      </div>
    </div>
  );
};

export default SettingsPage;